import i18n from "i18next";
import { initReactI18next } from "react-i18next";
import LanguageDetector from "i18next-browser-languagedetector";

// English translations
import enCommon from "./locales/en/common.json";
import enNavigation from "./locales/en/navigation.json";
import enAuth from "./locales/en/auth.json";
import enEmployee from "./locales/en/employee.json";
import enDocuments from "./locales/en/documents.json";
import enSettings from "./locales/en/settings.json";
import enLocation from "./locales/en/location.json";
import enSchedule from "./locales/en/schedule.json";
import enAdmin from "./locales/en/admin.json";
import enData from "./locales/en/data.json";
import enWelcome from "./locales/en/welcome.json";
import enPublic from "./locales/en/public.json";
import enOnboarding from "./locales/en/onboarding.json";
import enTraining from "./locales/en/training.json";

// Spanish translations
import esCommon from "./locales/es/common.json";
import esNavigation from "./locales/es/navigation.json";
import esAuth from "./locales/es/auth.json";
import esEmployee from "./locales/es/employee.json";
import esDocuments from "./locales/es/documents.json";
import esSettings from "./locales/es/settings.json";
import esLocation from "./locales/es/location.json";
import esSchedule from "./locales/es/schedule.json";
import esAdmin from "./locales/es/admin.json";
import esData from "./locales/es/data.json";
import esWelcome from "./locales/es/welcome.json";
import esPublic from "./locales/es/public.json";
import esOnboarding from "./locales/es/onboarding.json";
import esTraining from "./locales/es/training.json";

// Portuguese translations
import ptCommon from "./locales/pt/common.json";
import ptNavigation from "./locales/pt/navigation.json";
import ptAuth from "./locales/pt/auth.json";
import ptEmployee from "./locales/pt/employee.json";
import ptDocuments from "./locales/pt/documents.json";
import ptSettings from "./locales/pt/settings.json";
import ptLocation from "./locales/pt/location.json";
import ptSchedule from "./locales/pt/schedule.json";
import ptAdmin from "./locales/pt/admin.json";
import ptData from "./locales/pt/data.json";
import ptWelcome from "./locales/pt/welcome.json";
import ptPublic from "./locales/pt/public.json";
import ptOnboarding from "./locales/pt/onboarding.json";
import ptTraining from "./locales/pt/training.json";

const resources = {
  en: {
    common: enCommon,
    navigation: enNavigation,
    auth: enAuth,
    employee: enEmployee,
    documents: enDocuments,
    settings: enSettings,
    location: enLocation,
    schedule: enSchedule,
    admin: enAdmin,
    data: enData,
    welcome: enWelcome,
    public: enPublic,
    onboarding: enOnboarding,
    training: enTraining,
  },
  es: {
    common: esCommon,
    navigation: esNavigation,
    auth: esAuth,
    employee: esEmployee,
    documents: esDocuments,
    settings: esSettings,
    location: esLocation,
    schedule: esSchedule,
    admin: esAdmin,
    data: esData,
    welcome: esWelcome,
    public: esPublic,
    onboarding: esOnboarding,
    training: esTraining,
  },
  pt: {
    common: ptCommon,
    navigation: ptNavigation,
    auth: ptAuth,
    employee: ptEmployee,
    documents: ptDocuments,
    settings: ptSettings,
    location: ptLocation,
    schedule: ptSchedule,
    admin: ptAdmin,
    data: ptData,
    welcome: ptWelcome,
    public: ptPublic,
    onboarding: ptOnboarding,
    training: ptTraining,
  },
};

i18n
  .use(LanguageDetector)
  .use(initReactI18next)
  .init({
    resources,
    fallbackLng: "en",
    defaultNS: "common",
    ns: ["common", "navigation", "auth", "employee", "documents", "settings", "location", "schedule", "admin", "data", "welcome", "public", "onboarding", "training"],

    detection: {
      order: ["localStorage", "navigator"],
      lookupLocalStorage: "effitrack_language",
      caches: ["localStorage"],
    },

    interpolation: {
      escapeValue: false,
    },

    react: {
      useSuspense: true,
    },
  });

export default i18n;
